<div class="modal-header border-bottom-0" ngbAutoFocus>
  <div class="col-12 text-end">
    <a class="text-decoration-none back text-white" (click)="modal.close()"><i class="icon-close"></i></a>
    <h4 id="dialog-auto-name" class="modal-title title d-flex justify-content-center">Update Table</h4>
  </div>
</div>
<div class="modal-body item-details-content" ngbAutoFocus>
  <form [formGroup]="tableForm" (ngSubmit)="onSubmit()">
    <div class="row theme-color">
      <div class="mb-2">
        <label class="form-control-label">
          Table No
          <span class="required text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control form-control-sm"
          formControlName="object_nbr"
          [ngClass]="tableForm.get('object_nbr')?.touched && tableForm.get('object_nbr')?.invalid ? 'is-invalid' : ''"
        />
        <div class="invalid-feedback">Please enter Table No.</div>
      </div>
      <div class="mb-2">
        <label class="form-control-label">
          Number of chair
          <span class="required text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control form-control-sm"
          formControlName="num_chair"
          [ngClass]="tableForm.get('num_chair')?.touched && tableForm.get('num_chair')?.invalid ? 'is-invalid' : ''"
        />
        <div class="invalid-feedback">Please enter Number of chair.</div>
      </div>
    </div>
    <!-- Button section -->
    <div class="col-sm-12 text-center mt-2">
      <button type="submit" class="btn btn-primary" [disabled]="tableForm.invalid || isLoading">Update</button>
    </div>
  </form>
</div>
